import {EntityApiService, ApiClientService} from '@dofleini/security';

class NomenclaturesPaymentTypeApiService extends EntityApiService {

    getOne = ({paymentId}) => ApiClientService.get(this.getPath(`/${paymentId}`));

}

export default new NomenclaturesPaymentTypeApiService('/ms-core/api/paymenttypes');
